import { render } from "./TopBarView.vue?vue&type=template&id=b19624ba&scoped=true&ts=true"
import script from "./TopBarView.vue?vue&type=script&lang=ts"
export * from "./TopBarView.vue?vue&type=script&lang=ts"

import "./TopBarView.vue?vue&type=style&index=0&id=b19624ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19624ba"]])

export default __exports__